import type { FC } from 'react';

import { TextInput, Typography } from 'enable-ui';

import { Body, BodyBorderContainer, TableHeader } from '../styles/functional-test';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import type { ScoringRuleItem } from '../core/type';

import { COLOR_CONFIG } from 'constants/color';

import { CustomHeader } from './CustomHeader';

const FunctionalTestHeader = () => {
  return (
    <TableHeader
      style={{
        borderBottom: `1px solid rgba(0, 0, 0, 0.25)`,
      }}
    >
      <div style={{ minWidth: '50px' }}>
        <Typography weight={600} style={{ fontSize: 16, lineHeight: '22px', color: '#808080' }}>
          #
        </Typography>
      </div>
      <CustomHeader title="Begin time (s)" styleHeader={{ width: '33.33%' }} id="min" />
      <CustomHeader title="End time (s)" styleHeader={{ width: '33.33%' }} id="max" />
      <CustomHeader
        title="Achieved score"
        styleHeader={{ width: '33.33%', whiteSpace: 'normal' }}
        id="score"
      />
      <div style={{ minWidth: '26px' }}></div>
    </TableHeader>
  );
};

export const ScoringRuleTable: FC<{
  scoringRules: ScoringRuleItem[];
  onChangeValueSelectedFunctionalTest: (index: number, value: Record<string, string>) => void;
  onDelete: (index: number) => void;
}> = ({ scoringRules, onChangeValueSelectedFunctionalTest, onDelete }) => {
  const handleKeyPress = (e: any) => {
    const keyCode = e.keyCode || e.which;
    const keyValue = String.fromCharCode(keyCode);

    if (keyValue === '-') {
      e.preventDefault();
      e.preventDefault();
    }
  };

  const renderBodyTable = (item: ScoringRuleItem, index: number) => {
    return (
      <BodyBorderContainer
        key={index}
        $color={`${(index + 1) % 2 === 0 ? COLOR_CONFIG.doctor : COLOR_CONFIG.white}`}
        className="flex"
      >
        <Body>
          <div style={{ width: '50px', padding: '16px 8px' }}>
            <Typography style={{ fontSize: 18, lineHeight: '26px', color: '#808080' }}>
              {index + 1}.
            </Typography>
          </div>

          <div style={{ width: '33.33%', padding: '16px 8px' }}>
            <TextInput
              name="min"
              value={item.min}
              containerStyle={{ height: 30 }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                onChangeValueSelectedFunctionalTest(index, {
                  [e.target.name]: e.target.value,
                });
              }}
              type="number"
              min={1}
              onKeyPress={handleKeyPress}
              disabled={index !== 0}
            />
          </div>
          <div style={{ width: '33.33%', padding: '16px 8px' }}>
            <TextInput
              name="max"
              value={item.max}
              containerStyle={{ height: 30 }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onChangeValueSelectedFunctionalTest(index, {
                  [e.target.name]: e.target.value,
                })
              }
              type="number"
              min={1}
              onKeyPress={handleKeyPress}
              helperText={
                Number(item.min) > Number(item.max)
                  ? 'The End time must be after than the Begin time.'
                  : undefined
              }
              color={Number(item.min) > Number(item.max) ? 'error' : undefined}
            />
          </div>
          <div style={{ width: '33.33%', padding: '16px 8px' }}>
            <TextInput
              name="score"
              value={item.score}
              containerStyle={{ height: 30 }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                onChangeValueSelectedFunctionalTest(index, {
                  [e.target.name]: e.target.value,
                });
              }}
              type="number"
              min={0}
              onKeyPress={handleKeyPress}
            />
          </div>
        </Body>
        <div style={{ width: '50px', padding: '16px 8px' }}>
          <CloseIcon style={{ cursor: 'pointer' }} onClick={() => onDelete(index)} />
        </div>
      </BodyBorderContainer>
    );
  };

  return (
    <div style={{ marginTop: 6 }}>
      <FunctionalTestHeader />
      {scoringRules.length ? (
        <div>
          {scoringRules.map((el, index) => {
            return renderBodyTable(el, index);
          })}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
